// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--2vH2G","text":"style-module--text--3OktQ","icon":"style-module--icon--1kuoN"};